module.exports = __webpack_public_path__ + "img/Monte_Kope_38.e6fd22ab.jpg";